import React from 'react';
import{FaEnvelope} from "react-icons/fa"

const Under_const = () => {
  return (

      <div className='main'>
          <section></section>
          <div className='under_c'>
            
            <h2>Under construction</h2>
            <br/><br/><br/><br/><br/>
            {/* <a className='email' href="mailto:someone@yoursite.com"><FaEnvelope /> Reach Out To Us</a> */}
        </div>

      </div>
    
  );
};
  
export default Under_const; 